export default function A() {
  return (
    <div
      className="home_a_main"
      style={{
        width: "90%",
        maxWidth: "1247px",
        margin: "auto",
        display: "grid",
        gridTemplateColumns: "repeat(3,1fr)",
        gap: "2%",
        marginTop: "180px",
      }}
    >
      <div
        style={{
          position: "relative",
          borderRadius: "10px",
          backgroundColor: "white",
        }}
      >
        <img
          style={{
            width: "100%",
            borderTopRightRadius: "10px",
            borderTopLeftRadius: "10px",
            filter: "brightness(80%)",
          }}
          src="https://forever.travel-assets.com/flex/flexmanager/images/2020/11/12/TVLY_StoreFrontRefresh_BrandPromise_FitForYou_sfimg_562x240_20201111.jpg?impolicy=fcrop&w=900&h=386&q=mediumHigh"
          alt="img"
        />
        <div
          style={{
            position: "absolute",
            top: "40%",
            left: "3%",
            color: "white",
          }}
        >
          <h2 style={{ textShadow: "2px 2px 8px grey" }}>
            Find your perfect trip
          </h2>
        </div>
        <div style={{ width: "95%", margin: "auto", fontSize: "small" }}>
          <p>
            Plan a trip for the whole family—from family travel tips to
            family-friendly filters, our tools make it easy.
          </p>
        </div>
      </div>
      <div
        style={{
          position: "relative",
          borderRadius: "10px",
          backgroundColor: "white",
        }}
      >
        <img
          style={{
            width: "100%",
            borderTopRightRadius: "10px",
            borderTopLeftRadius: "10px",
            filter: "brightness(80%)",
          }}
          src="https://forever.travel-assets.com/flex/flexmanager/images/2020/11/12/TVLY_StoreFrontRefresh_BrandPromise_Transparency_sfimg_562x240_20201111.jpg?impolicy=fcrop&w=900&h=386&q=mediumHigh"
          alt="img"
        />
        <div
          style={{
            position: "absolute",
            top: "40%",
            left: "3%",
            color: "white",
          }}
        >
          <h2 style={{ textShadow: "2px 2px 8px grey" }}>
            Book with flexibility
          </h2>
        </div>
        <div style={{ width: "95%", margin: "auto", fontSize: "small" }}>
          <p>
            Looking for a change of scenery, but want something flexible? With
            free cancellation on most hotels, you can book with peace of mind.
          </p>
        </div>
      </div>
      <div
        style={{
          position: "relative",
          borderRadius: "10px",
          backgroundColor: "white",
        }}
      >
        <img
          style={{
            width: "100%",
            borderTopRightRadius: "10px",
            borderTopLeftRadius: "10px",
            filter: "brightness(80%)",
          }}
          src="https://forever.travel-assets.com/flex/flexmanager/images/2020/11/12/TVLY_StoreFrontRefresh_BrandPromise_GotYourBack_sfimg_562x240_20201111.jpg?impolicy=fcrop&w=900&h=386&q=mediumHigh"
          alt="img"
        />
        <div
          style={{
            position: "absolute",
            top: "40%",
            left: "3%",
            color: "white",
          }}
        >
          <h2 style={{ textShadow: "2px 2px 8px grey" }}>
            Find your perfect trip
          </h2>
        </div>
        <div style={{ width: "95%", margin: "auto", fontSize: "small" }}>
          <p>
            Need more help along your journey? We offer 24/7 support on social
            and through virtual agents onsite.
          </p>
        </div>
      </div>
    </div>
  );
}
